import * as types from '../types/wishlistTypes';

export const toggleWishlistId = (id) => ({ type: types.WISHLIST_TOGGLE_ID, payload: id });
export const removeWishlistId = (id) => ({ type: types.WISHLIST_REMOVE_ID, payload: id });
export const clearWishlist = () => ({ type: types.WISHLIST_CLEAR });

export const selectWishlistIds = (state) => state.wishlist?.ids ?? [];
